<div mat-dialog-title>
  <h2>Select a Question</h2>
</div>
<mat-dialog-content>
  <div class="editor-question-form__input">
    <span class="fs__md fw__500">Question</span>
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
      <input
        #input
        matInput
        [matAutocomplete]="auto"
        type="text"
        placeholder="Select a question"
        aria-label="Select a question"
        (input)="filter()"
        (focus)="filter()"
      />
      <mat-autocomplete
        requireSelection
        #auto="matAutocomplete"
        class="eiq-no-wrap-option"
        [classList]="'eiq-no-wrap-option'"
        (optionSelected)="onQuestionSelected($event)"
      >
        @for (prevQuestion of filteredQuestions$(); track prevQuestion.id) {
          <mat-option [value]="prevQuestion.id">{{ prevQuestion.code }} - {{ prevQuestion.title | toPlainText }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="onClose()">Cancel</button>
  <button mat-flat-button [color]="'primary'" (click)="onComplete()">Select</button>
</mat-dialog-actions>
